import apiClient from '@/api/client';
import type { AutomationConfig } from '@/types/automation';

export const getAutomationConfig = async (): Promise<AutomationConfig> => {
  const response = await apiClient.get<AutomationConfig>('/automation/config');
  return response.data;
};

export const updateAutomationConfig = async (
  data: AutomationConfig,
): Promise<AutomationConfig> => {
  const response = await apiClient.put<AutomationConfig>('/automation/config', data);
  return response.data;
};
